import React, { useEffect, useState, useRef } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';

import api from './../../service/api';

import CreateSupplier from './create';
import { formatDocument, formatPhone } from '../../service/format';

export default function Supplier(){
    var emptySupplier = {
        code: null,
        name: '',
        document_number: '',
        phone: '',
        address: ''
    }

    const [supplier, setSupplier] = useState(emptySupplier);
    const [suppliers, setSuppliers] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [updateDialog, setUpdateDialog] = useState(false);
    const [dialog, setDialog] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);

    const toast = useRef(null);
    const dt = useRef(null);

    const listSuppliers = () => {
        api().get('supplier/list').then(response => {
            if(response.status === 200 && response.data.result){
                setSuppliers(response.data.data);
            }
        });
    }

    const onInputChange = (e, name) => {
        const val = e.value || (e.target && e.target.value) || '';
        let _supplier = { ...supplier };
        _supplier[`${name}`] = val;

        setSupplier(_supplier);
    }

    const openNew = () => {
        setSupplier(emptySupplier);
        setSubmitted(false);
        setDialog(true);
        setDisabled(false);
    }

    const confirmDelete = (_supplier) => {
        setSupplier({ ..._supplier });
        setDeleteDialog(true);
    }

    const hideDeleteDialog = () => {
        setSupplier({ ...emptySupplier });
        setDeleteDialog(false);
    }

    const handleDelete = () => {
        setDisabled(true);
        api().delete('/supplier/' + supplier.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listSuppliers();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setSupplier(emptySupplier);
            setDisabled(false);
            setDeleteDialog(false);
        });
    }

    const onHide = () => {
        setSupplier({...emptySupplier});
        setUpdateDialog(false);
    }

    const onCreate = (data) => {
        setDialog(false);
        if(data.result) listSuppliers();
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo fornecedor" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Fornecedor</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-info mr-2" onClick={() => {
                    setSupplier({...rowData});
                    setUpdateDialog(true);
                }} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2" onClick={() => confirmDelete(rowData)} />
            </div>
        );
    }

    const deleteDialogFooter = (
        <>
            { !disabled && <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />}
            <Button label="Sim" icon="pi pi-check" loading={disabled} className="p-button-text" onClick={handleDelete} />
        </>
    );

    useEffect(() => {
        listSuppliers()
    }, []);

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>
                    <CreateSupplier updateSupplier={supplier} visible={dialog} disabled={disabled} onCreate={onCreate} handleCancel={() => setDialog(false)} />

                    <DataTable ref={dt} value={suppliers} 
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="name" sortable header="Nome" headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column body={rowData => formatDocument(rowData.document_number)} header="CPF / CNPJ"></Column>
                        <Column body={rowData => rowData.phone ? <a href={"tel:" + rowData.phone.replace(/\D/g, '')}>{formatPhone(rowData.phone)}</a> : '-'} header="Telefone" ></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>

                    <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {supplier && <span>Você tem certeza que deseja remover este fornecedor?</span>}
                        </div>
                    </Dialog>

                    <Dialog visible={updateDialog} style={{ width: '450px' }} header="Alterar Fornecedor" modal className="p-fluid" footer={() => {
                        return(
                            <>
                                <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={onHide} />
                                <Button label="Salvar" onClick={() => {
                                    if(!supplier.name) return setSubmitted(true);

                                    setDisabled(true);
                                    api().post('/supplier/update', {...supplier}).then(response => {
                                        setDisabled(false);
                                        if(response.status === 200 && response.data.result){
                                            setUpdateDialog(false);
                                            listSuppliers();
                                            toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                                        } else {
                                            toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                                        }
                                    });

                                }} loading={disabled} icon="pi pi-check" className="p-button-text"  />
                            </>
                        );
                    }} onHide={onHide}>
                                    
                        <div className="field">
                            <label htmlFor="name">Nome</label>
                            <InputText disabled={disabled} id="name" value={supplier.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus />
                            {submitted && !supplier.name && <small className="p-invalid p-error">Este campo é obrigatório.</small>}
                        </div>

                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="document_number">CPF / CNPJ</label>
                                <InputText disabled={disabled} id="document_number" value={supplier.document_number} onChange={(e) => onInputChange(e, 'document_number')}  />
                            </div>
                        </div>

                        <div className="field">
                            <label htmlFor="phone">Telefone</label>
                            <InputText disabled={disabled} id="phone" value={supplier.phone} onChange={(e) => onInputChange(e, 'phone')} />
                        </div>

                        <div className="field">
                            <label htmlFor="address">Endereço</label>
                            <InputText disabled={disabled} id="address" value={supplier.address} onChange={(e) => onInputChange(e, 'address')} />
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );    
}